const points = [
  {
    title: "A short call, then a written scope",
    text: "We look at one close cycle together and agree what \"done\" means before anything is built. If the work is not worth doing, I say so on that call.",
  },
  {
    title: "A pilot, ten business days",
    text: "One workflow, live, tested against a real client or a real close, with before and after numbers you can check yourself. Priced in writing before it starts.",
  },
  {
    title: "A build, then care",
    text: "Two or three more workflows at a fixed price, then a monthly agreement with capped hours if you want them maintained. Documented well enough to run without me.",
  },
];

export default function Craft() {
  return (
    <section className="t-sec" aria-labelledby="craft-title">
      <div className="t-wrap t-split">
        <figure className="t-rise">
          <img
            className="t-photo t-split__photo"
            src="/code.jpg"
            width={1920}
            height={1280}
            alt="Source code on a monitor, lit dimly against a dark room"
            loading="lazy"
            decoding="async"
          />
        </figure>

        <div>
          <h2 id="craft-title" className="t-h2 t-rise">
            How it starts.
          </h2>

          <ul className="t-craft__list t-rise">
            {points.map((point) => (
              <li className="t-craft__item" key={point.title}>
                <span className="t-craft__mark" aria-hidden="true">
                  —
                </span>
                <div>
                  <h3 className="t-h3">{point.title}</h3>
                  <p>{point.text}</p>
                </div>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
